import App from 'app';
import { useEffect, useState } from 'react';
import Select from "react-select";
import { GetUser, SetUser, UpdateMe } from 'services/Session';
import { GetSetting } from 'services/Setting';

export function userProfile(props) {
	let user = GetUser()
	const [setting, setSetting] = useState({});
	const [view, setView] = useState('view-profile')
	const [name, setName] = useState(user?.name)
	const [nip, setNIP] = useState(user?.nip)
	const [gender, setGender] = useState({value: user?.gender, label: user?.gender=='female' ? 'Perempuan' : 'Laki-laki'})
	const [email, setEmail] = useState(user?.email)
	const [phone, setPhone] = useState(user?.phone)
	const [errorMessage, setErrorMessage] = useState('')
	useEffect(() => {
		const getData = async () => {
			await GetSetting(setSetting);
		};
		getData();
	}, []);
	return (
		<App user={user} setting={setting}>
			<div className='p-4'>
				{errorMessage && (
					<div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-md shadow-md flex items-center" style={{zIndex: 9999}}>
						<span>{errorMessage}</span>
						<button className="ml-4 text-white focus:outline-none" onClick={() => setErrorMessage('')}>✖</button>
					</div>
				)}
				<div className="flex flex-col items-center justify-center px-6 py-8 mx-auto text-gray-800">
					<div className="w-full text-sm bg-white rounded-md shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
						{view=='view-profile' && (
							<ViewProfile name={name} nip={nip} email={email} phone={phone} gender={gender} setView={setView}/>
						)}
						{view=='edit-profile' && (
							<EditProfile
								name={name} setName={setName}
								nip={nip} setNIP={setNIP}
								email={email} setEmail={setEmail}
								phone={phone} setPhone={setPhone}
								gender={gender} setGender={setGender}
								setView={setView} setErrorMessage={setErrorMessage}
							/>
						)}
						{view=='change-password' && (
							<ChangePassword setView={setView} setErrorMessage={setErrorMessage} />
						)}
					</div>
				</div>
			</div>
		</App>
	)
}

function ViewProfile({name, nip, email, phone, gender, setView}) {
	return (
		<div className="p-6 space-y-4 md:space-y-6 sm:p-8">
			<h3 className="font-bold leading-tight tracking-tight text-center mb-4">
				Profil Pengguna
			</h3>
			<table className="w-full ltr:text-left rtl:ext-right">
				<tbody>
					<tr>
						<th className="py-2 font-semibold ps-0" scope="row">Nama</th>
						<td className="py-2 text-right text-slate-500 dark:text-zink-200">{name}</td>
					</tr>
					<tr>
						<th className="py-2 font-semibold ps-0" scope="row">NIP HSI</th>
						<td className="py-2 text-right text-slate-500 dark:text-zink-200">{nip}</td>
					</tr>
					<tr>
						<th className="py-2 font-semibold ps-0" scope="row">Email</th>
						<td className="py-2 text-right text-slate-500 dark:text-zink-200">{email}</td>
					</tr>
					<tr>
						<th className="py-2 font-semibold ps-0" scope="row">Nomor WhatsApp</th>
						<td className="py-2 text-right text-slate-500 dark:text-zink-200">{phone}</td>
					</tr>
					<tr>
						<th className="py-2 font-semibold ps-0" scope="row">Jenis Kelamin</th>
						<td className="py-2 text-right text-slate-500 dark:text-zink-200">{gender?.label}</td>
					</tr>
				</tbody>
			</table>
			<div className="space-y-4 md:space-y-6">
				<button onClick={() => setView('edit-profile')} type="button" className="w-full text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-5 py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
					Perbarui
				</button>
				<button onClick={() => setView('change-password')} type="button" className="w-full text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-5 py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
					Ganti Kata Sandi
				</button>
			</div>
		</div>
	)
}

function EditProfile({ name, setName, nip, setNIP, email, setEmail, phone, setPhone, gender, setGender, setErrorMessage, setView }) {
	const [loading, setLoading] = useState(false)
	const inputClass = [
		'bg-gray-50',
		'block',
		'border',
		'border-gray-300',
		'p-2.5',
		'rounded-md',
		'w-full',
		'dark:bg-gray-700',
		'dark:border-gray-600',
		'dark:focus:border-sky-500',
		'dark:focus:ring-sky-500',
		'dark:placeholder-gray-400',
		'dark:text-white',
		'focus:border-sky-500',
		'focus:ring-sky-500',
	].join(' ')
	const handleSubmit = async (e) => {
		setLoading(true)
		e.preventDefault()
		try {
			const res = await UpdateMe({
				name: name,
				nip: nip,
				gender: gender?.value,
				email: email,
				phone: phone,
			})
			await SetUser(res?.data)
			alert(res?.data?.message?? 'Profil pengguna berhasil diperbarui.')
			setView('view-profile')
		} catch (e) {
			setErrorMessage(e?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
			setTimeout(() => {
				setErrorMessage('')
			}, 3000)
		}
		setLoading(false)
	}
	return (
		<div className="p-6 space-y-4 md:space-y-6 sm:p-8">
			<h3 className="font-bold leading-tight tracking-tight text-center mb-4">
				Ubah Profil Pengguna
			</h3>
			<form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
				<div>
					<label htmlFor="name" className="block mb-2 font-medium dark:text-white">Nama</label>
					<input onChange={(e) => setName(e.target.value)} value={name} name="name" id="name" className={inputClass} required autoFocus/>
				</div>
				<div>
					<label className="block mb-2 font-medium dark:text-white">Jenis Kelamin</label>
					<Select 
						placeholder="Pilih..."
						required
						value={gender} 
						onChange={(val) => setGender(val)} 
						options={[
							{value: 'male', label: 'Laki-laki'},
							{value: 'female', label: 'Perempuan'}
						]}
						styles={{
						control: (baseStyles, _state) => ({
							...baseStyles,
							backgroundColor: 'rgb(249 250 251 / 1)',
							padding: 2,
							borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
							borderRadius: '0.375rem',
						}),
						}}
					/>
				</div>
				<div>
					<label htmlFor="nip" className="block mb-2 font-medium dark:text-white">NIP HSI</label>
					<input onChange={(e) => setNIP(e.target.value)} value={nip}  name="nip" id="nip" placeholder={gender?.value=='female'?'ART134-0001':'ARN134-0001'} className={inputClass}/>
				</div>
				<div>
					<label htmlFor="email" className="block mb-2 font-medium dark:text-white">Email</label>
					<input onChange={(e) => setEmail(e.target.value)} value={email} type="email" name="email" id="email" placeholder="email@example.com" className={inputClass} required/>
				</div>
				<div>
					<label htmlFor="phone" className="block mb-2 font-medium dark:text-white">Nomor WhatsApp</label>
					<input onChange={(e) => setPhone(e.target.value)} value={phone} name="phone" id="phone" placeholder="081234567890" className={inputClass} required/>
				</div>
				<div className="grid gap-4 grid-flow-col justify-stretch">
					<button onClick={() => setView('view-profile')} type="button" className="py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400">Batal</button>
					<button type="submit" className="text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
						{loading ? (
							<svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
								<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
								<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
							</svg>
						) : (
							"Simpan"
						)}
					</button>
				</div>
			</form>
		</div>
	)
}

function ChangePassword({ setErrorMessage, setView }) {
	const [loading, setLoading] = useState(false)
	const [password, setPassword] = useState('')
	const [showPassword, setShowPassword] = useState(false)
	const inputClass = [
		'bg-gray-50',
		'block',
		'border',
		'border-gray-300',
		'p-2.5',
		'rounded-md',
		'w-full',
		'dark:bg-gray-700',
		'dark:border-gray-600',
		'dark:focus:border-sky-500',
		'dark:focus:ring-sky-500',
		'dark:placeholder-gray-400',
		'dark:text-white',
		'focus:border-sky-500',
		'focus:ring-sky-500',
	].join(' ')
	const handleSubmit = async (e) => {
		setLoading(true)
		e.preventDefault()
		try {
			const res = await UpdateMe({ password: password })
			await SetUser(res?.data)
			alert(res?.data?.message?? 'Kata sandi berhasil diperbarui.')
			setView('view-profile')
		} catch (e) {
			setErrorMessage(e?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
			setTimeout(() => {
				setErrorMessage('')
			}, 3000)
		}
		setLoading(false)
	}
	return (
		<div className="p-6 space-y-4 md:space-y-6 sm:p-8">
			<h3 className="font-bold leading-tight tracking-tight text-center mb-4">
				Ganti Kata Sandi
			</h3>
			<form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
				<div className="relative">
					<label htmlFor="password" className="block mb-2 font-medium text-gray-900 dark:text-white">Kata Sandi Baru</label>
					<input onChange={(e) => setPassword(e.target.value)} id="password" name="password" placeholder="••••••••" required type={showPassword ? "text" : "password"} className={inputClass}/>
					<div onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer" style={{ height: "100%", paddingTop: 25 }} >
						{showPassword ? (
							<svg className="w-5 h-5 text-gray-500 dark:text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor">
								<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" />
							</svg>
						) : (
							<svg className="w-5 h-5 text-gray-500 dark:text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
								<path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z" />
							</svg>
						)}
					</div>
				</div>
				<div className="grid gap-4 grid-flow-col justify-stretch">
					<button onClick={() => setView('view-profile')} type="button" className="py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400">Batal</button>
					<button type="submit" className="text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
						{loading ? (
							<svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
								<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
								<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
							</svg>
						) : (
							"Simpan"
						)}
					</button>
				</div>
			</form>
		</div>
	)
}